<mat-list role="list" [ngStyle]="{ width: listWidth }">
  @for (item of options; track item) {
    <mat-list-item
      role="listitem"
      class="basic-list-item"
      >
      <span class="item-description">{{ item[displayField] }}</span>
    </mat-list-item>
  }
</mat-list>
